var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSponsor6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 19,
    viewBox: "0 0 241 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Automattic svg",
    clipPath: "url(#clip0_2_8889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.9384 18.7C81.831 18.7 77.8694 14.33 77.8694 9.78184V9.21813C77.8694 4.59284 81.831 0.299988 87.9384 0.299988C94.0458 0.299988 98.0413 4.59284 98.0413 9.21813V9.78184C98.0413 14.33 94.0798 18.7 87.9384 18.7ZM94.774 9.26631C94.774 5.95152 92.3466 3.00289 87.9384 3.00289C83.5302 3.00289 81.1416 5.95634 81.1416 9.26631V9.68066C81.1416 12.9955 83.569 16.0019 87.9384 16.0019C92.3077 16.0019 94.774 12.9955 94.774 9.68066V9.26631Z",
    fill: "#3499CD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.9365 18.0303L16.6595 13.7904H6.53229L4.31362 18.0303H0.915222L10.2366 0.916687H12.931L22.4077 18.0303H18.9365ZM11.5037 4.25557L7.75086 11.4537H15.3876L11.5037 4.25557Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.1131 18.7C30.9231 18.7 28.0491 15.3563 28.0491 10.9141V0.916687H31.263V10.9622C31.263 14.1229 33.3603 16.0019 37.3461 16.0019C41.4388 16.0019 43.1186 14.1229 43.1186 10.9622V0.916687H46.3567V10.8996C46.3567 15.1539 43.638 18.7 37.1131 18.7Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M64.3777 3.59069V18.0447H61.1395V3.59069H53.6047V0.916687H71.9124V3.59069H64.3777Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M126.884 18.0303V4.48684L126.03 5.98042L118.806 18.0255H117.228L110.082 5.98042L109.227 4.48684V18.0303H106.067V0.916687H110.548L117.344 12.6582L118.15 14.1036L118.951 12.6582L125.685 0.916687H130.113V18.0303H126.884Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M154.591 18.0303L152.309 13.7904H142.192L139.992 18.0303H136.594L145.915 0.916687H148.605L158.057 18.0303H154.591ZM147.158 4.25557L143.405 11.4537H151.042L147.158 4.25557Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M171.107 3.59069V18.0447H167.874V3.59069H160.339V0.916687H178.642V3.59069H171.107Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M194.852 3.59069V18.0447H191.614V3.59069H184.079V0.916687H202.392V3.59069H194.852Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M210.364 18.0303V2.53554C211.655 2.53554 212.174 1.84175 212.174 0.916687H213.558V18.0303H210.364Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M238.895 5.74916C237.037 3.99249 234.572 3.00813 232.006 2.99808C227.399 2.99808 224.807 6.1346 224.807 9.3964V9.72884C224.807 12.9665 227.423 15.9923 232.239 15.9923C234.759 15.9452 237.17 14.9637 238.997 13.2412L240.939 15.2696C238.517 17.5102 235.318 18.7387 232.006 18.7C225.481 18.7 221.52 14.4842 221.52 9.85893V9.29522C221.52 4.66993 225.845 0.299988 232.162 0.299988C235.812 0.299988 239.128 1.81766 240.9 3.71596L238.895 5.74916Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M90.0747 6.25505C90.2166 6.34479 90.3389 6.46188 90.4343 6.59937C90.5298 6.73687 90.5965 6.89198 90.6304 7.05552C90.6644 7.21906 90.6649 7.38769 90.632 7.55144C90.5991 7.71518 90.5334 7.87071 90.4388 8.0088L87.4871 12.5474C87.3982 12.6857 87.2828 12.8054 87.1473 12.8994C87.0118 12.9934 86.859 13.06 86.6976 13.0954C86.5362 13.1307 86.3693 13.1341 86.2065 13.1054C86.0438 13.0767 85.8883 13.0164 85.749 12.928C85.4692 12.7458 85.2733 12.4612 85.2042 12.1362C85.1351 11.8113 85.1983 11.4724 85.3801 11.1935L88.3318 6.65494C88.5129 6.37597 88.7982 6.17971 89.1249 6.10925C89.4517 6.03879 89.7933 6.09989 90.0747 6.27914V6.25505Z",
    fill: "#010101"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 18.4,
    fill: "white",
    transform: "translate(0.915222 0.299988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor6);
export default __webpack_public_path__ + "static/media/sponsor 6.283adb434537eabebf9064c38c74027b.svg";
export { ForwardRef as ReactComponent };